







































































































































import { defineComponent, ref, watch } from '@vue/composition-api'

import { IReceipt, NgReason } from '@/types/receipt'
import { ReceiptValidation } from '@/types/ocr'

import { AppToggleButton } from '@/components/atoms'

type Props = {
  receipt: IReceipt
  validation: ReceiptValidation
  isValidationNg: boolean
  isFirstReceipt: boolean
  isLastReceipt: boolean
}

export default defineComponent({
  name: 'OcrActions',
  components: { AppToggleButton },
  props: {
    receipt: {
      type: Object,
      default: () => ({}),
    },
    validation: {
      type: Object,
      default: () => ({}),
    },
    isValidationNg: {
      type: Boolean,
      default: false,
    },
    isFirstReceipt: {
      type: Boolean,
      default: false,
    },
    isLastReceipt: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props, context) {
    const dialog = ref(false)
    const otherErrorText = ref<string>(props.receipt.otherNgReason)
    watch(
      () => props.receipt.id,
      () => {
        otherErrorText.value = props.receipt.otherNgReason
      },
    )
    const otherErrorTemplates = [
      'NGテンプレート1',
      'NGテンプレート2',
      'NGテンプレート3',
    ]
    const clickTemplate = (template: string) => {
      otherErrorText.value = template
    }
    const hasOtherError = () => {
      return otherErrorText.value.length !== 0
    }
    const reportOtherError = () => {
      const newReceipt = {
        ...props.receipt,
        otherNgReason: otherErrorText.value,
      }
      context.emit('update:receipt', newReceipt)
      dialog.value = false
    }
    const cancelOtherErrorInput = () => {
      dialog.value = false
      otherErrorText.value = props.receipt.otherNgReason
    }
    const removeOtherError = () => {
      const newReceipt = {
        ...props.receipt,
        otherNgReason: '',
      }
      context.emit('update:receipt', newReceipt)
      otherErrorText.value = ''
      dialog.value = false
    }

    const toggleError = (newNgReason: NgReason) => {
      let ngReason: null | NgReason = newNgReason
      if (props.receipt.ngReason === newNgReason) {
        ngReason = null
      }
      const newReceipt = {
        ...props.receipt,
        ngReason,
      }
      context.emit('update:receipt', newReceipt)
    }

    return {
      dialog,
      otherErrorText,
      otherErrorTemplates,
      clickTemplate,
      hasOtherError,
      reportOtherError,
      cancelOtherErrorInput,
      removeOtherError,
      toggleError,
      NgReason,
    }
  },
})
